/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import type { ExtractInjectionAPI, UiComponentFactoryParams } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../../aiPluginType';

import { useUIState } from './hooks/useUIState';
import { DiscardSessionScreen } from './screens/Discard';
import { LoadingSessionScreen } from './screens/Loading';

export interface SessionUIComponentProps {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	appearance: UiComponentFactoryParams['appearance'];
	providerFactory: ProviderFactory;
}

export function SessionUIComponent({ api, providerFactory, appearance }: SessionUIComponentProps): JSX.Element | null {
	const [state, dispatch] = useUIState(api);

	switch (state) {
		case 'discard':
			return <DiscardSessionScreen api={api} dispatch={dispatch} appearance={appearance} />;
		case 'loading':
			return (
				<LoadingSessionScreen
					api={api}
					providerFactory={providerFactory}
					appearance={appearance}
					dispatch={dispatch}
				/>
			);
		case 'idle':
		default:
			return null;
	}
}
